import { render, staticRenderFns } from "./GlossaryFilters.vue?vue&type=template&id=04ea9252&scoped=true&"
import script from "./GlossaryFilters.vue?vue&type=script&lang=js&"
export * from "./GlossaryFilters.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryFilters.vue?vue&type=style&index=0&id=04ea9252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ea9252",
  null
  
)

export default component.exports